import { put, takeLatest } from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";
import {
  activeSegmentAPI,
  createSegmentAPI,
  deactiveSegmentAPI,
  deleteMemberAPI,
  deleteSegmentAPI,
  getActiveSegmentAPI,
  getDataMemberAPI,
  getListSegmentAPI,
  regenerateSegmentMemberAPI,
  updateMemberAPI,
  updateSegmentAPI,
} from "redux/api/lcmAPI";
import {
  activeSegment,
  createSegment,
  deactiveSegment,
  deleteMember,
  deleteSegment,
  getActiveSegment,
  getActiveSegmentSuccess,
  getDataMember,
  getDataMemberSuccess,
  getListSegment,
  getListSegmentSuccess,
  regenerate,
  updateIsDelete,
  updateLoadingPagi,
  updateMember,
  updateSegment,
  updateTotalRecord,
  updateTotalSegment,
} from "redux/slices/lcm";
import { setShowLoadingScreen } from "redux/slices/global";
import {
  loadCategory,
  loadObjectCategory,
} from "redux/slices/objectsManagement";

export default function* LcmSaga() {
  yield takeLatest(getListSegment.type, GetListSegment);
  yield takeLatest(getDataMember.type, GetDataMember);
  yield takeLatest(getActiveSegment.type, GetActiveSegment);
  yield takeLatest(activeSegment.type, ActiveSegment);
  yield takeLatest(deactiveSegment.type, DeactiveSegment);
  yield takeLatest(createSegment.type, CreateSegment);
  yield takeLatest(updateSegment.type, UpdateSegment);
  yield takeLatest(deleteSegment.type, DeleteSegment);
  yield takeLatest(regenerate.type, Regenerate);
  yield takeLatest(updateMember.type, UpdateMember);
  yield takeLatest(deleteMember.type, DeleteMember);
}

function* GetListSegment(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getListSegmentAPI(action.payload);
    yield put(getListSegmentSuccess(response.data.data.data));
    yield put(updateTotalSegment(response.data.data.total_records));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* GetDataMember(action) {
  try {
    if (action.payload.pagination) {
      yield put(updateLoadingPagi(true));
    } else {
      yield put(setShowLoadingScreen(true));
    }
    const response = yield getDataMemberAPI(action.payload);
    if (action.payload.pagination) {
      yield put(updateTotalRecord(response.data.data.total_record));
    } else {
      yield put(getDataMemberSuccess(response.data.data));
    }
    yield put(updateLoadingPagi(false));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    yield put(updateLoadingPagi(false));

    Notification("error", error.response.data.error);
  }
}

function* GetActiveSegment() {
  try {
    const response = yield getActiveSegmentAPI();
    yield put(getActiveSegmentSuccess(response.data.data.active));
  } catch (error) {}
}

function* ActiveSegment() {
  try {
    yield put(setShowLoadingScreen(true));
    yield activeSegmentAPI();
    Notification("success", "Active segment success");
    yield put(getActiveSegment());
    yield put(loadObjectCategory());
    yield put(loadCategory());
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* DeactiveSegment() {
  try {
    yield put(setShowLoadingScreen(true));
    yield deactiveSegmentAPI();
    Notification("success", "Deactive segment success");
    yield put(getActiveSegment());
    yield put(loadObjectCategory());
    yield put(loadCategory());

    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));

    Notification("error", error.response.data.error);
  }
}

function* CreateSegment(action) {
  try {
    yield createSegmentAPI(action.payload);
    Notification("success", "Create segment success");
    yield put(getListSegment({ search_str: "", pagination: 0 }));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* UpdateSegment(action) {
  try {
    yield updateSegmentAPI(action.payload);
    yield put(getListSegment({ search_str: "", pagination: 0 }));
    Notification("success", "Update segment success");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* DeleteSegment(action) {
  try {
    yield deleteSegmentAPI(action.payload);
    Notification("success", "Delete segment success");
    yield put(updateIsDelete(Math.random()));
    yield put(getListSegment({ search_str: "", pagination: 0 }));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* Regenerate(action) {
  try {
    yield regenerateSegmentMemberAPI(action.payload);
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
function* UpdateMember(action) {
  try {
    yield updateMemberAPI(action.payload.data);
    yield put(getDataMember(action.payload.load));
    Notification("success", "Update segment member success");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
function* DeleteMember(action) {
  try {
    yield deleteMemberAPI(action.payload.data);
    yield put(getDataMember(action.payload.load));
    Notification("success", "Delete segment member success");
    yield put(updateTotalRecord(null));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
